const ENCODING = 'array-buffer-v1';

const isStoredBinary = (value) => value?.encoding === ENCODING && value.bytes instanceof ArrayBuffer;

export const encodePhotoBinary = async (value) => {
  if (!value || isStoredBinary(value)) return value;
  if (!(value instanceof Blob)) throw new Error('Neispravan lokalni zapis fotografije.');
  const bytes = typeof value.arrayBuffer === 'function'
    ? await value.arrayBuffer()
    : await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error || new Error('Fotografiju nije moguće pročitati.'));
      reader.readAsArrayBuffer(value);
    });
  return { encoding: ENCODING, type: value.type, bytes };
};

export const decodePhotoBinary = (value) => {
  if (!value || value instanceof Blob) return value;
  if (!isStoredBinary(value)) throw new Error('Neispravan lokalni zapis fotografije.');
  return new Blob([value.bytes], { type: value.type });
};
